import { type ReactNode, createContext, useCallback, useContext } from 'react';

import { isResourceName } from './resourceNames';
import { useResourceDisplayNames } from './useResourceDisplayNames';

type ResolveResourceName = (name: string) => string;

const defaultResolve: ResolveResourceName = (name: string) => name;

const ResourceDisplayNameContext =
  createContext<ResolveResourceName>(defaultResolve);

export const ResourceDisplayNameProvider = ({
  input,
  additionalNames,
  children,
}: {
  input: unknown;
  additionalNames?: string[];
  children: ReactNode;
}) => {
  const { resolvedNames } = useResourceDisplayNames(input, additionalNames);

  const resolve: ResolveResourceName = useCallback(
    (name: string) => {
      if (!isResourceName(name)) return name;
      return resolvedNames.get(name) || name;
    },
    [resolvedNames],
  );

  return (
    <ResourceDisplayNameContext.Provider value={resolve}>
      {children}
    </ResourceDisplayNameContext.Provider>
  );
};

export const useResolveResourceName = (): ResolveResourceName =>
  useContext(ResourceDisplayNameContext);
